import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-label": "Page navigation example"
}
const _hoisted_2 = { class: "pagination justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  class: "page-link",
  href: "#",
  tabindex: "-1"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "이전")
], -1)
const _hoisted_4 = {
  class: "page-link",
  href: "#"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("a", {
  class: "page-link",
  href: "#"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "다음")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show_yn)
    ? (_openBlock(), _createBlock("nav", _hoisted_1, [
        _createVNode("ul", _hoisted_2, [
          _createVNode("li", {
            class: ["page-item", { disabled: _ctx.prevButton.isDisabled() }],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.prevButton.click()))
          }, [
            _hoisted_3
          ], 2),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageItemList, (pageItem) => {
            return (_openBlock(), _createBlock("li", {
              key: pageItem.page,
              class: ["page-item", { active: pageItem.isPageItemActive(_ctx.currentPage), disabled: pageItem.isDisabled() }],
              onClick: ($event: any) => (pageItem.click())
            }, [
              _createVNode("a", _hoisted_4, _toDisplayString(pageItem.page), 1)
            ], 10, ["onClick"]))
          }), 128)),
          _createVNode("li", {
            class: ["page-item", { disabled: _ctx.nextButton.isDisabled() }],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextButton.click()))
          }, [
            _hoisted_5
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}